<template>
  <div class="financialfirm-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/06/icon_jinrong_gs.png"
           alt="">
      金融公司管理
    </div>
    <el-form ref="form"
             class="financialfirmlist_search"
             :inline="true">
      <el-form-item label="金融公司名称">
        <el-input size="small"
                  v-model="inputName"
                  class="financialName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   size="small"
                   class="search_btn"
                   @click="handleSearchClick">查询
        </el-button>
      </el-form-item>
      <el-form-item class="btn_box">
        <router-link to="/manage/financialfirm/addFinancialfirm">
          <el-button type="warning"
                     size="small"
                     class="add_btn">
            添加
          </el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="financial_table">
      <el-table :data="financialfirmList.result"
                style="width: 100%"
                height="100%">
        <el-table-column fixed
                         label="序号"
                         align="center"
                         type="index"
                         width="50">
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="金融公司名称"
                         min-width="130">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.companyName}} <span class="nameStyle"
                    v-if="scope.row.theDefault === '1'">默认</span></div>
          </template>
        </el-table-column>
        <el-table-column label="年利率"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div>{{scope.row.interestRale}}%</div>
          </template>
        </el-table-column>
        <el-table-column label="添加时间"
                         header-align="center"
                         align="left"
                         width="94">
          <template slot-scope="scope">
            <div>{{scope.row.createDate}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="remarks"
                         label="备注"
                         header-align="center"
                         align="center"
                         min-width="94">
          <template slot-scope="scope">
            <div>{{scope.row.remarks}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.bankCompanyId)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.bankCompanyId)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{financialfirmList.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="financialfirmList.pageSize"
                     layout="prev, pager, next"
                     :total="financialfirmList.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { financialfirmList, deleteFinancialfirm } from 'apis/index'
import { mapState } from 'vuex'
export default {
  name: 'Container',
  data () {
    return {
      financialfirmList: [],
      inputName: ''
    }
  },
  computed: mapState({
    showAddFinancialfirm: state => state.financialfirm.show
  }),
  mounted () {
    this.getFinancialfirmList()
  },
  methods: {
    getFinancialfirmList (item) { // 获取所有金融公司列表
      item = !item ? '' : item
      financialfirmList({
        companyName: item
      }).then(res => {
        if (res.data.code === 0) {
          this.financialfirmList = res.data.data.pagination
          // console.log(this.financialfirmList)
        }
      })
    },
    handleCurrentChange (val) { // 分页
      let pageNum = val
      financialfirmList({ pageNum }).then(res => {
        this.financialfirmList = res.data.data.pagination
      })
    },
    handleDeleteClick (item) { // 删除公司信息
      deleteFinancialfirm({ bankCompanyId: item }).then(res => {
        if (res.data.code === 0) {
          for (var i = 0; i < this.financialfirmList.result.length; i++) { // 从当前列别表中删除该数据
            if (this.financialfirmList.result[i].bankCompanyId === item) {
              this.financialfirmList.result.splice(i, 1)
            }
          }
        }
      })
    },
    handleUpdateClick (id) { // 修改公司信息
      this.$router.push({ path: 'financialfirm/addFinancialfirm', query: { item: id } })
    },
    handleSearchClick () { // 查询
      this.getFinancialfirmList(this.inputName)
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.financialfirm-container
  height 100%
  padding 20px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    .title_img
      background #9231ff
      border-radius 50%
  .financialfirmlist_search
    width 100%
    position relative
    .el-form-item
      margin-bottom 5px
    .search_btn
      searchBtn()
      margin-left 22px
    .btn_box
      width 80px
      float right
      position absolute
      top 0
      right 0
      .add_btn
        addBtn()
    .el-input
      margin-left 10px
      width 150px
  .financial_table
    height calc(100% - 170px)
  .el-table
    background #f7f9fb
    th
      background #e7f0f8
      .cell
        height 25px
        line-height 25px
    .cell
      size12()
      .nameStyle
        color #ffffff
        padding 2px 4px
        background #FF6F12
        border-radius 2px
      .el-button
        padding 6px 14px
        width 28px
        cursor pointer
        height 28px
        margin 0 8px
        &.update
          update()
        &.delete
          delete()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
